import * as runtime from '@/api/runtime'
import {
  SearchSeparateDictionaryRequestToJSON,
  CreateSeparateDictionaryRequestToJSON,
  DeleteSeparateDictionaryRequest,
  GetSeparateDictionaryRequestToJSON,
  SeparateDictionary,
  DeleteSeparateDictionaryRequestToJSON,
  CreateSeparateDictionaryRequest,
  GetSeparateDictionaryRequest,
  SearchSeparateDictionaryRequest,
  SeparateDictionaryFromJSON,
  UpdateSeparateDictionaryRequest,
  UpdateSeparateDictionaryRequestToJSON
} from '@/api'
import { HTTPQuery } from '@/api/runtime'

export class SeparateDictionaryApi extends runtime.BaseAPI {
  /**
   * 分かち辞書を検索する
   * 分かち辞書検索
   */
  async searchSeparateDictionary(
    request: SearchSeparateDictionaryRequest
  ): Promise<SeparateDictionary[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchSeparateDictionaryRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/separate-dictionary/search',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SeparateDictionaryFromJSON)
    ).value()
  }

  /**
   * 分かち辞書を取得する
   * 分かち辞書取得
   */
  async getSeparateDictionary(
    request: GetSeparateDictionaryRequest
  ): Promise<SeparateDictionary> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetSeparateDictionaryRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/separate-dictionary/${queryParameters.id}`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      SeparateDictionaryFromJSON(jsonValue)
    ).value()
  }

  /**
   * 分かち辞書を作成する
   * 分かち辞書作成
   */
  async createSeparateDictionary(
    request: CreateSeparateDictionaryRequest
  ): Promise<number> {
    const bodyParameters: runtime.HTTPBody = CreateSeparateDictionaryRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/separate-dictionary',
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.env_separate_dictionary_id)
    ).value()
  }

  /**
   * 分かち辞書を更新する
   * 分かち辞書更新
   */
  async updateSeparateDictionary(
    request: UpdateSeparateDictionaryRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateSeparateDictionaryRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/separate-dictionary/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 分かち辞書を削除する
   * 分かち辞書削除
   */
  async deleteSeparateDictionary(
    request: DeleteSeparateDictionaryRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteSeparateDictionaryRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/separate-dictionary/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
